(() => {
  if (customElements.get('component-lookbook')) {
    return;
  }

  class ComponentLookbook extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.querySelector('button[type="button"]').addEventListener('click', this.toggle.bind(this));
      document.addEventListener('click', this.close.bind(this));

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.getProduct();
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 1000px 0px'
      }).observe(this);
    }

    toggle() {
      this.toggleAttribute('open');
    }

    close(e) {
      const outside = !e.target.closest('.swiper-wrapper') && !e.target.closest('button');
      if(outside) {
        this.removeAttribute('open');
      }
    }

    getProduct() {
      let handles = JSON.parse(
        this.querySelector('[type="product-handles/json"]').textContent
      );

     const result = handles.map(handle => {
        return new Promise((resolve) => {
          fetch(window.Shopify.routes.root + `products/${handle}?view=lookbook`)
          .then(response => {
            if(response.status != 200) {
              resolve('');
            }
            resolve(response.text())
          }).catch(() => resolve(''))
        })
      })

      Promise.all([...result]).then((values) => {
        const html = new DOMParser()
        .parseFromString(values.join(''), 'text/html');

        this.querySelector('[data-products]').prepend(...html.querySelectorAll('[data-slide]'))
        this.closest('[data-lookbook-block]').removeAttribute('is-hidden');
      })
    }
  }

  customElements.define('component-lookbook', ComponentLookbook);
})();
